import React from "react";
import clsx from "clsx";
import topLeftBgImage from "~/images/testimonials-bg-tl.svg";
import bottomRightBgImage from "~/images/testimonials-bg-br.svg";
import topRightBgImage from "~/images/testimonials-bg-tr.svg";
import bottomLeftBgImage from "~/images/testimonials-bg-bl.svg";
import gatekeeperScreenshotImage from "~/images/Gatekeeper_cropped.jpg";
import TestimonialBubble from "./TestimonialBubble";
import ParallaxBanner from "./ParallaxBanner";
import "./Testimonials.css";

type TestimonialContent = {
  readonly content: string;
  readonly name?: string;
  readonly position: string;
};

type TestimonialsProps = {
  readonly title?: string;
  readonly imageBackground?: boolean;
  readonly content: readonly TestimonialContent[];
};

function TestimonialsContent({
  imageBackground,
  title,
  content,
}: TestimonialsProps) {
  return (
    <div
      className={clsx(
        "testimonials-section",
        imageBackground && "testimonials-section-image-background",
      )}
    >
      <div className="testimonials-bg">
        <div className="testimonials-bg-inner">
          <img src={topLeftBgImage} alt="" className="top-left" />
          <img src={bottomRightBgImage} alt="" className="bottom-right" />
          <img src={bottomLeftBgImage} alt="" className="bottom-left" />
          <img src={topRightBgImage} alt="" className="top-right" />
        </div>
      </div>
      <div className="testimonials-content">
        {title && <h2>{title}</h2>}
        <div className="bubbles">
          {content.map((c) => (
            <TestimonialBubble
              key={c.position}
              name={c.name}
              position={c.position}
              content={c.content}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function Testimonials(props: TestimonialsProps) {
  if (props.imageBackground) {
    return (
      <ParallaxBanner image={gatekeeperScreenshotImage} dontConstrainWidth>
        <TestimonialsContent {...props} />
      </ParallaxBanner>
    );
  }
  return <TestimonialsContent {...props} />;
}

export type { TestimonialsProps };
export default Testimonials;
